import { CertificationProviderStatusEnum } from 'app/library/certification-provider/enums/certification-provider-status.enum';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { Certification } from '../models/certification';

export class SetCertification {
    static readonly type = '[Certification] SetCertification';

    constructor(public payload: Certification) {}
}

export class UnsetCertification {
    static readonly type = '[Certification] UnsetCertification';
}

export class UnsetCertifications {
    static readonly type = '[Certification] UnsetCertifications';
}

export class FetchCertification {
    static readonly type = '[Certification] FetchCertification';

    constructor(public payload: string) {}
}

export class FetchCertificationSuccess {
    static readonly type = '[Certification] FetchCertificationSuccess';

    constructor(public payload: Certification) {}
}

export class FetchCertificationFailure {
    static readonly type = '[Certification] FetchCertificationFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddCertifications {
    static readonly type = '[Certification] AddCertifications';

    constructor(public payload: Certification[]) {}
}

export class CreateCertification {
    static readonly type = '[Certification] CreateCertification';

    constructor(
        public payload: {
            name: string;
            providerId?: string;
            hasExpirationDate?: boolean;
            targetCount?: number;
        }
    ) {}
}

export class CreateCertificationSuccess {
    static readonly type = '[Certification] CreateCertificationSuccess';

    constructor(public payload: Certification) {}
}

export class CreateCertificationFailure {
    static readonly type = '[Certification] CreateCertificationFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class MoveCertification {
    static readonly type = '[Certification] MoveCertification';

    constructor(
        public payload: {
            certificationId: string;
            providerId: string;
        }
    ) {}
}

export class MoveCertificationSuccess {
    static readonly type = '[Certification] MoveCertificationSuccess';

    constructor(public payload: Certification) {}
}

export class MoveCertificationFailure {
    static readonly type = '[Certification] MoveCertificationFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class CreateInternalCertification {
    static readonly type = '[Certification] CreateInternalCertification';

    constructor(
        public payload: {
            name: string;
            providerId: string;
            validityPeriod: number;
            file: File;
            hasExpirationDate: boolean;
            targetCount?: number;
        }
    ) {}
}

export class CreateInternalCertificationSuccess {
    static readonly type = '[Certification] CreateInternalCertificationSuccess';

    constructor(public payload: Certification) {}
}

export class CreateInternalCertificationFailure {
    static readonly type = '[Certification] CreateInternalCertificationFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertification {
    static readonly type = '[Certification] UpdateCertification';

    constructor(
        public payload: {
            id: string;
            name: string;
            validityPeriod?: number;
            hasExpirationDate?: boolean;
            targetCount?: number;
        }
    ) {}
}

export class UpdateCertificationSuccess {
    static readonly type = '[Certification] UpdateCertificationSuccess';

    constructor(public payload: Certification) {}
}

export class UpdateCertificationFailure {
    static readonly type = '[Certification] UpdateCertificationFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertificationStatus {
    static readonly type = '[Certification] UpdateCertificationStatus';

    constructor(
        public payload: {
            id: string;
            status: CertificationProviderStatusEnum;
        }
    ) {}
}

export class UpdateCertificationStatusSuccess {
    static readonly type = '[Certification] UpdateCertificationStatusSuccess';

    constructor(public payload: Certification) {}
}

export class UpdateCertificationStatusFailure {
    static readonly type = '[Certification] UpdateCertificationStatusFailure';
}

export class DeleteCertification {
    static readonly type = '[Certification] DeleteCertification';

    constructor(public payload: string) {}
}

export class DeleteCertificationSuccess {
    static readonly type = '[Certification] DeleteCertificationSuccess';

    constructor(public payload: string) {}
}

export class DeleteCertificationFailure {
    static readonly type = '[Certification] DeleteCertificationFailure';

    constructor(public payload: string) {}
}

export class SetCertifications {
    static readonly type = '[Certification] SetCertifications';

    constructor(public payload: Certification[]) {}
}

export class FetchCertifications {
    static readonly type = '[Certification] FetchCertifications';

    constructor(
        public payload: {
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            provider: string[];
            statuses: number[];
        }
    ) {}
}

export class FetchCertificationsSuccess {
    static readonly type = '[Certification] FetchCertificationsSuccess';
}

export class FetchCertificationsFailure {
    static readonly type = '[Certification] FetchCertificationsFailure';
}

export class ToggleSelectedCertification {
    static readonly type = '[Certification] ToggleSelectedCertification';

    constructor(public payload: string) {}
}

export class SelectFilteredCertifications {
    static readonly type = '[Certification] SelectFilteredCertifications';
}

export class DeselectSelectedCertifications {
    static readonly type = '[Certification] DeselectSelectedCertifications';
}

export class SearchCertifications {
    static readonly type = '[Certification] SearchCertifications';

    constructor(public payload: string) {}
}
